import MDEditor from "@uiw/react-md-editor";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import useFetch from "hooks/useFetch";
import {
  displaySuccess,
  displayError,
} from "stores/flashmessages/flashMiddleware";

const UpdateGlossaryTitle = ({ definition, handleClose, reload }) => {
  const [newTitle, setNewTitle] = useState("");
  const { t } = useTranslation("admin");
  const { patch } = useFetch();

  const handleSubmit = async (event) => {
    event.preventDefault();
    await patch(
      `/admin/glossaries/${definition.id}`,
      { title: newTitle },
      displaySuccess(t("glossary_definition_title_updated")),
      displayError(t("glossary_definition_title_not_updated"))
    );
    handleClose();
    reload();
  };

  console.log(definition);

  return (
    <div>
      <h6 className="mt-5">
        {t("define_title")} -{" "}
        <small className="text-secondary">{t("use_markdown")}</small>
      </h6>
      <MDEditor
        value={newTitle}
        onChange={setNewTitle}
        className="mb-1"
        height={250}
      />
      <small>{t("before_modification")} : {definition.title}</small>
      {newTitle && newTitle.length > 0 && (
        <div className="text-center my-4">
          <Button className="btn-warning text-white" onClick={handleSubmit}>
            {t("edit_title")}
          </Button>
        </div>
      )}
    </div>
  );
};

export default UpdateGlossaryTitle;
